import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import user from './user'
import config from './config'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    config,
    gift: {
      namespaced: true,
    },
  },
  getters: {
    isShowPostCode: (state) => {
      return state.user.userIpCountry === 'US' || state.user.userIpCountry === 'CA'
    },
    /** 获取用户的商城状态
     * normal: 不需要任何操作
     * need_login: 开启登录限制且未登录
     * need_level: 开启等级限制且等级不足
     */
    storeUserStatus: (state) => {
      const DAILY_GIFT_STATUS = {
        NORMAL: 'normal',
        NEED_LOGIN: 'need_login',
        NEED_LEVEL: 'need_level',
      }
      if (!state.user.isLogin) {
        if (state.config.gameConfig.login_active === 1) {
          return DAILY_GIFT_STATUS.NEED_LOGIN
        } else {
          return DAILY_GIFT_STATUS.NORMAL
        }
      } else {
        if (state.config.gameConfig.enable_pay_threshold === 1) {
          if (state.user.userInfo.pay_threshold === 1) {
            return DAILY_GIFT_STATUS.NORMAL
          } else {
            return DAILY_GIFT_STATUS.NEED_LEVEL
          }
        } else {
          return DAILY_GIFT_STATUS.NORMAL
        }
      }
    },
  },
})

export default store
